import * as React from "react";
import {observer} from "mobx-react";
import {withAppStores} from "../../../../../AppStores";
import type {AppState} from "../../../../../data/state/AppState";
import type {TransportLayer} from "../../../../../data/TransportLayer";
import type {PortfolioGroup} from "../../../../../data/models/PortfolioGroup";
import {Field} from "../../../../widgets/form/field/Field";
import {DateFormatter} from "../../../../../utils/format/DateFormatter";
import {ClickToEditInput} from "../../../../widgets/input/clicktoedit/ClickToEditInput";
import {FieldDataType, XyiconFeature} from "../../../../../generated/api/base";
import {StringUtils} from "../../../../../utils/data/string/StringUtils";
import {PortfolioGroupPortfolios} from "./PortfolioGroupPortfolios";

interface IPortfolioGroupDetailsContentProps {
	readonly portfolioGroups: PortfolioGroup[];
	readonly appState?: AppState;
	readonly transport?: TransportLayer;
}

@withAppStores("appState", "transport")
@observer
export class PortfolioGroupDetailsContent extends React.Component<IPortfolioGroupDetailsContentProps> {
	constructor(props: IPortfolioGroupDetailsContentProps) {
		super(props);
	}

	private async updateApi() {
		const portfolioGroup = this.props.portfolioGroups[0];

		if (portfolioGroup.id) {
			// we're in edit mode
			await this.props.transport.services.feature.update(portfolioGroup.id, XyiconFeature.PortfolioGroup, {
				portfolios: portfolioGroup.portfolioIds,
				name: portfolioGroup.name,
			});
		}
	}

	private isNameValid = (name: string) => {
		const {portfolioGroups, appState} = this.props;
		const portfolioGroup = portfolioGroups[0];

		const portfolioGroupListArray = appState.actions.getList<PortfolioGroup>(XyiconFeature.PortfolioGroup);
		const otherGroupsWithSameName = portfolioGroupListArray.find((g) => g.id !== portfolioGroup.id && StringUtils.equalsIgnoreCase(g.name, name));

		return !otherGroupsWithSameName;
	};

	private getErrorMessage = (name: string) => {
		return !name.trim() ? "Name cannot be empty!" : this.isNameValid(name) ? "" : "Name not valid!";
	};

	private onChangeName = (name: string) => {
		if (this.isNameValid(name)) {
			this.props.portfolioGroups[0].name = name;
			this.updateApi();
		}
	};

	private get portfolioGroupMemberCount() {
		const {appState, portfolioGroups} = this.props;

		return portfolioGroups[0].portfolioIds.filter((id) => appState.actions.getFeatureItemById(id, XyiconFeature.Portfolio)).length;
	}

	public override render() {
		const {portfolioGroups, appState} = this.props;
		const portfolioGroup = portfolioGroups[0];

		return (
			<div className="DetailsContent">
				{portfolioGroups.length === 0 && <div className="noData">Please select a Portfolio Group</div>}
				{portfolioGroups.length === 1 && (
					<>
						<div className="header">
							<Field label="Name">
								<ClickToEditInput
									value={portfolioGroup.name}
									onChange={this.onChangeName}
									getErrorMessage={this.getErrorMessage}
									dataType={FieldDataType.SingleLineText}
									noButtons={true}
								/>
							</Field>
							<Field label="Portfolios">{this.portfolioGroupMemberCount}</Field>
							<Field label="Last Updated">{DateFormatter.format(portfolioGroup.lastModifiedAt)}</Field>
							<Field label="Last Updated By">{appState.actions.renderName(portfolioGroup.lastModifiedBy)}</Field>
						</div>
						<PortfolioGroupPortfolios portfolioGroup={portfolioGroup} />
					</>
				)}
			</div>
		);
	}
}
